import { Component } from '@angular/core';

@Component({
  selector: 'app-chart-loading',
  templateUrl: './chart-loading.component.html',
  styleUrls: ['./chart-loading.component.scss'],
  standalone:true
})
export class ChartLoadingComponent {}
